export enum LabelLanguage {
  English = 'English',
  French = 'French',
  BilingualEnglishFrenchEnglishFirst = 'BilingualEnglishFrenchEnglishFirst',
  BilingualEnglishFrenchFrenchFirst = 'BilingualEnglishFrenchFrenchFirst',
  Spanish = 'Spanish',
  BilingualEnglishSpanishEnglishFirst = 'BilingualEnglishSpanishEnglishFirst',
  BilingualEnglishSpanishSpanishFirst = 'BilingualEnglishSpanishSpanishFirst',
}